import { render, staticRenderFns } from "./CommandSystem.vue?vue&type=template&id=f4d3f628&scoped=true"
import script from "./CommandSystem.vue?vue&type=script&lang=js"
export * from "./CommandSystem.vue?vue&type=script&lang=js"
import style0 from "./CommandSystem.vue?vue&type=style&index=0&id=f4d3f628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d3f628",
  null
  
)

export default component.exports